import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import App from 'app' // from baseUrl: src/

const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER

if (GTM_ID)
  TagManager.initialize({
    gtmId: GTM_ID,
  })

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)
